/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rating[_ngcontent-%COMP%]{box-shadow:0 1px 3px 0 rgb(0 0 0 / 30%);border-radius:10px;padding:5px;text-align:center;width:200px}.ratingOver[_ngcontent-%COMP%]{position:absolute;width:190px;height:60px;z-index:10000}"];
export { styles as styles };
